import { render, staticRenderFns } from "./UnresolvedLeaves.vue?vue&type=template&id=cab5d280&scoped=true"
import script from "./UnresolvedLeaves.vue?vue&type=script&lang=js"
export * from "./UnresolvedLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab5d280",
  null
  
)

export default component.exports